export const EVALUATION = [
	{
		id: 5,
		description:
			"Dominio sobresaliente. Ejemplos sólidos, relevantes y repetibles en otros contextos	",
	},
	{
		id: 4,
		description:
			"Evidencia sólida de la competencia. Respuestas claras, estructuradas y coherentes	",
	},
	{
		id: 3,
		description:
			"Demuestra la competencia de manera aceptable, pero con margen de mejora	",
	},
	{ id: 2, description: "Muestra la competencia de forma muy limitada o inconsistente	" },
	{
		id: 1,
		description: "No demuestra la competencia. Respuestas vagas, sin ejemplos claros	",
	},
]

export const CAPACIDADES=["Habilidad técnica","Habilidad digital"]
export const INTERACTIONS=["Interna","Externa"]